import React, { Component }  from 'react';
import axios from "axios";
import $ from "jquery";
import Layout from "./Components/Layout";
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import PhoneNumberComponent from './Components/PhoneNumberComponent';
import BannerDesigns from "./Components/BannerDesigns";
import PaginatedItems from "./Components/Pagination";

const badgeStyles = `
.table-container {
    max-height: calc(100vh - 380px);
    overflow-y: auto;
    overflow-x: hidden;
}
.table-container thead th {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #f8f9fa !important;
}
.table-container table {
    table-layout: fixed;
    width: 100%;
}
.table-container td {
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
}
`;

export class SupplierContacts extends Component{
    state = {
        records: [],
        search: "",
        pageNumber:1,
        totalItems: 0
    }

    getSuppliers(search, pageNumber) {
        let _self = this;
        let dataObj = {
            search: search,
            page: pageNumber
        }
        
        axios.put(`suppliers-contacts`, dataObj)
            .then(response => {
                const records = response.data.contacts;
                const totalItems = response.data.total_records;
                _self.setState({ records });
                _self.setState({ totalItems });
            }).catch(error => {
            console.error('There was an error!', error);
        });
    }

    componentDidMount() {
        const suppliersSelectedOptionName = localStorage.getItem('suppliersSelectedOptionName') || '';
            this.setState({
                search: suppliersSelectedOptionName,
            }, () => {
                this.getSuppliers(suppliersSelectedOptionName, this.state.pageNumber)
            });


    }

    formatDateTime(dateString){
        if(dateString !== undefined)
        {
            const myDate = new Date(dateString);

            return  myDate.toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            });

        }
    };

    openPage(e, ContactId){
        e.preventDefault();
        window.location.href = "/edit-contact/"+ContactId;
    }

    onSearch(e)
    {
        this.setState({ search: e.target.value })
    }

    onKeyUp (e)
    {
        if (e.charCode === 13) {
            console.log('13');
            this.onSearchClick(e);
        }
    };

    onSearchClick(e)
    {
        this.setState({ search: e.target.value })
        this.getSuppliers(e.target.value, this.state.pageNumber)
    }

    paginatePage = (page)=> {
        console.log(`pageNumber ${page}`)
        const pageNumber = page;
        this.setState({ pageNumber });
        this.getSuppliers(this.state.search, pageNumber);
    }

    onQuotesClick(e){
        e.preventDefault();
        window.location.href = "/suppliers-data";
    }

    openQuotesPage(e, SupplierDataId){
        e.preventDefault();
        window.location.href = "/suppliers-data/"+SupplierDataId;
    }

    render() {
        return (
            <Layout>
                <style>{badgeStyles}</style>
                <div style={{ height: 'calc(100vh - 70px)', overflow: 'hidden', paddingTop: '20px' }}>
                    <section className="section pb-0" style={{ marginBottom: '0px', paddingTop: '20px', paddingBottom: '0px' }}>
                        <div className="container-fluid" style={{ paddingLeft: '24px' }}>
                            
                            {/* Header Section */}
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <p style={{ color: '#6b7280', fontSize: '16px', margin: 0 }}>Manage and view all supplier contact information</p>
                                <div className="d-flex" style={{ gap: '10px' }}>
                                    <button 
                                        className='btn btn-primary btn-sm d-flex align-items-center' 
                                        onClick={(e) => this.onQuotesClick(e)}
                                        style={{ gap: '8px', padding: '8px 16px' }}
                                    >
                                        <i className={'ti-book'}></i>
                                        Latest Quotes
                                    </button>
                                </div>
                            </div>

                            <div className="row" style={{'@media print': {display: 'none'}}}>
                                <div className="col-lg-12 mb-3">
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="input-group">
                                                <input 
                                                    type="text" 
                                                    className="form-control"
                                                    onKeyPress={(e) => this.onKeyUp(e)}
                                                    onChange={(e) => this.onSearch(e)}
                                                    placeholder="Search by company name..."
                                                    value={this.state.search}
                                                    style={{padding: '20px'}} 
                                                    aria-describedby="basic-addon2"
                                                />
                                                <div className="input-group-append">
                                                    <span onClick={(e) => this.onSearchClick(e)} className="input-group-text ti-search" id="basic-addon2"></span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Supplier Contacts List Section */}
                            <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                                <div style={{ padding: '24px', borderBottom: '1px solid #e5e7eb' }}>
                                    <h5 style={{ fontWeight: '600', margin: 0 }}>Supplier Contacts ({this.state.totalItems} contacts)</h5>
                                </div>
                                
                                <div className="table-responsive table-container">
                                    <table className="table table-hover mb-0">
                                        <thead style={{ background: '#f8f9fa' }}>
                                            <tr>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '100px' }}>Actions</th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '200px' }}>Company</th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '150px' }}>Name</th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '200px' }}>Email</th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '130px' }}>Cell Phone</th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '130px' }}>Office Phone</th>
                                                <th style={{ padding: '12px 8px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center', width: '120px' }}>Created</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.records.length === 0 ? (
                                                <tr>
                                                    <td colSpan="7" style={{ padding: '32px', textAlign: 'center', color: '#6b7280' }}>
                                                        <i className="ti-user" style={{ fontSize: '48px', color: '#6c757d' }}></i>
                                                        <p className="mt-3 mb-0">No supplier contacts found</p>
                                                    </td>
                                                </tr>
                                            ) : (
                                                this.state.records.map((p, index) => (
                                                    <React.Fragment key={index}>
                                                        <tr data-toggle={`collapse`} data-target={`#row${index}`}
                                                            className="clickable" style={{cursor: 'pointer', borderTop: index > 0 ? '1px solid #f3f4f6' : 'none'}}>
                                                            <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>
                                                                <button 
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    onClick={(e) => this.openQuotesPage(e, p.ContactData[0]?.SupplierId)}
                                                                    title="View Quotes"
                                                                >
                                                                    <i className="ti-eye"></i>
                                                                </button>
                                                            </td>
                                                            <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center', fontWeight: '600' }} title={p.company}>{p.company}</td>
                                                            <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }} title={p.ContactData[0]?.Name}>{p.ContactData[0]?.Name || '-'}</td>
                                                            <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }} title={p.ContactData[0]?.Email}>{p.ContactData[0]?.Email || '-'}</td>
                                                            <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>
                                                                {p.ContactData[0]?.CellPhone ? 
                                                                    <PhoneNumberComponent phoneNumber={p.ContactData[0].CellPhone}/> : '-'
                                                                }
                                                            </td>
                                                            <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }}>
                                                                {p.ContactData[0]?.OfficePhone ? 
                                                                    <PhoneNumberComponent phoneNumber={p.ContactData[0].OfficePhone}/> : '-'
                                                                }
                                                            </td>
                                                            <td style={{ padding: '12px 8px', border: 'none', textAlign: 'center' }} title={p.ContactData[0]?.DateTimeCreated ? this.formatDateTime(p.ContactData[0].DateTimeCreated) : '-'}>
                                                                {p.ContactData[0]?.DateTimeCreated ? 
                                                                    this.formatDateTime(p.ContactData[0].DateTimeCreated) : '-'
                                                                }
                                                            </td>
                                                        </tr>
                                                                <tr id={`row${index}`} className="collapse">
                                                                    <td colSpan="7" style={{ backgroundColor: '#f8f9fa', padding: '20px' }}>
                                                                        <div className="row mb-3">
                                                                            <div className="col-md-6">
                                                                                <div className="card">
                                                                                    <div className="card-header">
                                                                                        <h6 className="mb-0">Company Details</h6>
                                                                                    </div>
                                                                                    <div className="card-body">
                                                                                        <div className="row">
                                                                                            <div className="col-6"><strong>Payment Terms:</strong></div>
                                                                                            <div className="col-6">{p.paymentTerms || '-'}</div>
                                                                                        </div>
                                                                                        <div className="row">
                                                                                            <div className="col-6"><strong>Credit Line:</strong></div>
                                                                                            <div className="col-6">{p.creditLine || '-'}</div>
                                                                                        </div>
                                                                                        <div className="row">
                                                                                            <div className="col-6"><strong>Shipping Address:</strong></div>
                                                                                            <div className="col-6">{p.shippingAddress || '-'}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <div className="card">
                                                                                    <div className="card-header">
                                                                                        <h6 className="mb-0">Shipping Details</h6>
                                                                                    </div>
                                                                                    <div className="card-body">
                                                                                        <div className="row">
                                                                                            <div className="col-6"><strong>FOB Origin:</strong></div>
                                                                                            <div className="col-6">{p.fobOrigin || '-'}</div>
                                                                                        </div>
                                                                                        <div className="row">
                                                                                            <div className="col-6"><strong>FOB Destination:</strong></div>
                                                                                            <div className="col-6">{p.fobDest || '-'}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {p.ContactData.length > 1 && (
                                                                            <div className="card">
                                                                                <div className="card-header">
                                                                                    <h6 className="mb-0">All Contacts</h6>
                                                                                </div>
                                                                                <div className="card-body p-0">
                                                                                    <div className="table-responsive">
                                                                                        <table className="table table-sm mb-0">
                                                                                            <thead style={{ backgroundColor: '#f1f3f4' }}>
                                                                                                <tr>
                                                                                                    <th>Name</th>
                                                                                                    <th>Email</th>
                                                                                                    <th>Cell Phone</th>
                                                                                                    <th>Office Phone</th>
                                                                                                    <th>Created</th>
                                                                                                </tr>
                                                                                            </thead>
                                                                                            <tbody>
                                                                                                {p.ContactData.map((x, contactIndex) => (
                                                                                                    <tr key={contactIndex}>
                                                                                                        <td>{x.Name}</td>
                                                                                                        <td>{x.Email}</td>
                                                                                                        <td>
                                                                                                            <PhoneNumberComponent phoneNumber={x.CellPhone}/>
                                                                                                        </td>
                                                                                                        <td>
                                                                                                            <PhoneNumberComponent phoneNumber={x.OfficePhone}/>
                                                                                                        </td>
                                                                                                        <td>{this.formatDateTime(x.DateTimeCreated)}</td>
                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                    </React.Fragment>
                                                ))
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                {this.state.totalItems > 0 && (
                                    <div className="pagination-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 24px', borderTop: '1px solid #e5e7eb' }}>
                                        <div className="pagination-info">
                                            <span style={{ color: '#6c757d', fontSize: '14px' }}>
                                                Total: {this.state.totalItems} contacts
                                            </span>
                                        </div>
                                        <PaginatedItems 
                                            total={this.state.totalItems}
                                            onPageChange={this.paginatePage}
                                            currentPage={this.state.pageNumber}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                </div>
            </Layout>
        );
    }
}

export default SupplierContacts;
